import React from "react";
import { Row, Col, Card } from "react-bootstrap";

const ModelOption = (props) => {
  const MODELS = {
    cars: {
      value: "all_vehicles",
      name: "vehicles",
    },
    all_services: {
      value: "all_services",
      name: "services",
    },
    all_parts_accessories: {
      value: "all_parts_accessories",
      name: "accessories",
    },
    all_rentals: {
      value: "all_rentals",
      name: "rentals",
    },
    all_apparels_merchandises: {
      value: "all_apparels_merchandises",
      name: "apparels",
    },
  };
  return (
    <>
      <Row className="my-5">
        {Object.values(MODELS).map((model) => (
          <Col key={model.value} xs={6} lg={4} xl={3} className="my-1">
            <Card
              className={`border-0 shadwo-sm select-card ${
                props.model !== model.value
                  ? `select-card__${model.name}`
                  : `select-card__${model.name}--selected text-white`
              } cursor-pointer`}
              onClick={() => props.setModel(model.value, model.name)}
            >
              <Card.Body>
                <p className="text-capitalize">{model.name}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default ModelOption;
